var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneticHealthScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 322",
    d: "M38 32H34C22.9543 32 14 40.9543 14 52V113C14 119.627 19.3726 125 26 125C32.6274 125 38 119.627 38 113V32Z",
    fill: "#306153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 323",
    d: "M43 104H47C58.0457 104 67 95.0457 67 84V23C67 16.3726 61.6274 11 55 11C48.3726 11 43 16.3726 43 23V104Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 325",
    d: "M101 104H105C116.046 104 125 95.0457 125 84V23C125 16.3726 119.627 11 113 11C106.373 11 101 16.3726 101 23V104Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 324",
    d: "M96 53H91.58C80.7663 53 72 61.7663 72 72.58V116C72 122.627 77.3726 128 84 128C90.6274 128 96 122.627 96 116V53Z",
    fill: "#306153"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneticHealthScreen);
export default __webpack_public_path__ + "static/media/GeneticHealthScreen.a28c8623ad8f6b37fa4a6b116b663d69.svg";
export { ForwardRef as ReactComponent };